import { getUserCourses } from "@app/modules/courses/services";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SetCoursesList } from "@app/modules/courses/store/actions";
import { selectCoursesLoading } from "@app/modules/courses/store/selectors";
import { Course } from "@app/types/interfaces";

export const useLoadCourses = () => {
  const dispatch = useDispatch();

  const coursesLoaded = useSelector(selectCoursesLoading);

  const [loadingCourses, setLoadingCourses] = useState(true);

  useEffect(() => {
    if (coursesLoaded) {
      setLoadingCourses(false);
      return;
    }
    getCourses();
  }, []);

  const getCourses = async () => {
    try {
      const { results } = await getUserCourses();
      const courses = results.map((course: Course) => course);
      dispatch(SetCoursesList(courses));
      setLoadingCourses(false);
    } catch (error) {
      setLoadingCourses(false);
      throw error;
    }
  };

  return {
    loadingCourses,
  };
};
